import * as React from 'react'
import type { SVGProps } from 'react'
function SvgStaedtStromerzeugungFossil2174038519118(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 129.53 118.72"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m42.62,118.72H1.5c-.41,0-.81-.17-1.09-.47-.28-.3-.43-.7-.41-1.11L5.32,22.49c.04-.79.7-1.42,1.5-1.42h30.48c.8,0,1.45.62,1.5,1.42l5.32,94.65c.02.41-.12.81-.41,1.11-.28.3-.68.47-1.09.47Zm-39.53-3h37.94l-5.15-91.65H8.23L3.09,115.72Z" />
      <path d="m128.03,111.62h-42.7c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h41.06l-5.04-54.23h-27.74l-.65,7c-.08.83-.82,1.44-1.63,1.35-.83-.08-1.43-.81-1.35-1.63l.78-8.36c.07-.77.72-1.36,1.49-1.36h30.47c.77,0,1.42.59,1.49,1.36l5.32,57.23c.04.42-.1.84-.38,1.15-.28.31-.69.49-1.11.49Z" />
      <path d="m85.33,111.62h-32.46c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h30.82l-5.04-54.23h-28.99c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h30.36c.77,0,1.42.59,1.49,1.36l5.32,57.23c.04.42-.1.84-.38,1.15-.28.31-.69.49-1.11.49Z" />
      <path d="m84.19,20.93c-6.08,0-12.29-1.69-17.62-5.84C49.93,1.74,37.5-2.77,23.19,13.65c-.54.62-1.49.69-2.12.15-.62-.54-.69-1.49-.15-2.12,15.82-18.15,29.91-13.05,47.5,1.06,12.34,9.63,30.73,4.18,37.47-3.66.54-.63,1.49-.7,2.12-.16.63.54.7,1.49.16,2.12-4.73,5.5-14.17,9.9-23.98,9.9Z" />
      <path d="m83.33,37.24c-11.87,0-23.45-3.25-29.35-8.97-.6-.58-.61-1.53-.03-2.12.58-.6,1.53-.61,2.12-.03,10.3,9.97,40.88,11.65,54.7-.07.63-.54,1.58-.46,2.11.17.54.63.46,1.58-.17,2.11-7.24,6.14-18.43,8.9-29.37,8.9Z" />
    </svg>
  )
}
export default SvgStaedtStromerzeugungFossil2174038519118
